import { colors } from "../constants/colors.js";
const charts = {
  gauge: {
    colors: {
      default: [colors.sand[600], colors.black.white],
      sand: [colors.sand[600], colors.black.white],
      forest: [colors.forest[600], colors.forest[100]],
      blaze: [colors.blaze[600], colors.blaze[100]],
      volt: [colors.volt[600], colors.volt[100]]
    },
    gradients: {
      default: [{
        color: colors.sand[500],
        offset: "0%"
      }, {
        color: colors.sand[100],
        offset: "100%"
      }],
      sand: [{
        color: colors.sand[500],
        offset: "0%"
      }, {
        color: colors.sand[100],
        offset: "100%"
      }],
      forest: [{
        color: colors.forest[600],
        offset: "24%"
      }, {
        color: "#fff",
        offset: "78%"
      }],
      volt: [{
        color: colors.volt[600],
        offset: "0%"
      }, {
        color: colors.volt[100],
        offset: "100%"
      }],
      blaze: [{
        color: colors.blaze[600],
        offset: "0%"
      }, {
        color: colors.blaze[100],
        offset: "100%"
      }]
    }
  },
  bar: {
    colors: {
      default: ["sand", "sand_dark", "forest", "forest_dark", "blaze", "blaze_dark", "black", "volt", "volt_dark"],
      sand: ["sand", "sand_dark", "forest", "forest_dark", "blaze", "blaze_dark", "black", "volt", "volt_dark"],
      forest: ["forest", "forest_dark", "sand", "sand_dark", "blaze", "blaze_dark", "black", "volt", "volt_dark"],
      volt: ["volt", "volt_dark", "forest", "forest_dark", "blaze", "blaze_dark", "black", "sand", "sand_dark"],
      blaze: ["blaze", "blaze_dark", "black", "sand", "forest", "volt", "sand_dark", "forest_dark", "volt_dark"]
    },
    gradients: {
      sand: [{
        color: colors.sand[400],
        offset: "0%"
      }, {
        color: colors.sand[500],
        offset: "100%"
      }],
      sand_dark: [{
        color: colors.sand[600],
        offset: "0%"
      }, {
        color: colors.sand[700],
        offset: "100%"
      }],
      forest: [{
        color: colors.forest[500],
        offset: "0%"
      }, {
        color: colors.forest[600],
        offset: "100%"
      }],
      forest_dark: [{
        color: colors.forest[700],
        offset: "0%"
      }, {
        color: colors.forest[800],
        offset: "100%"
      }],
      volt: [{
        color: colors.volt[500],
        offset: "0%"
      }, {
        color: colors.volt[600],
        offset: "100%"
      }],
      volt_dark: [{
        color: colors.volt[700],
        offset: "0%"
      }, {
        color: colors.volt[800],
        offset: "100%"
      }],
      blaze: [{
        color: colors.blaze[500],
        offset: "0%"
      }, {
        color: colors.blaze[600],
        offset: "100%"
      }],
      blaze_dark: [{
        color: colors.blaze[700],
        offset: "0%"
      }, {
        color: colors.blaze[800],
        offset: "100%"
      }],
      black: [{
        color: colors.black[500],
        offset: "0%"
      }, {
        color: colors.black[600],
        offset: "100%"
      }]
    }
  },
  line: {
    colors: {
      default: [colors.sand[500], colors.forest[600], colors.black[600], colors.volt[500], colors.blaze[500], colors.blaze[800]],
      sand: [colors.sand[500], colors.forest[600], colors.black[600], colors.volt[500], colors.blaze[500], colors.blaze[800]],
      forest: [colors.forest[600], colors.sand[500], colors.black[600], colors.volt[500], colors.blaze[500], colors.blaze[800]],
      volt: [colors.volt[500], colors.forest[600], colors.black[600], colors.sand[500], colors.blaze[500], colors.blaze[800]],
      blaze: [colors.blaze[500], colors.blaze[800], colors.black[600], colors.sand[500], colors.forest[600], colors.volt[500]]
    },
    gradients: {
      default: [{
        color: colors.sand[500],
        offset: "0%"
      }, {
        color: colors.black.white,
        offset: "100%"
      }],
      sand: [{
        color: colors.sand[500],
        offset: "0%"
      }, {
        color: colors.black.white,
        offset: "100%"
      }],
      forest: [{
        color: colors.forest[600],
        offset: "0%"
      }, {
        color: colors.black.white,
        offset: "100%"
      }],
      volt: [{
        color: colors.volt[600],
        offset: "0%"
      }, {
        color: colors.black.white,
        offset: "100%"
      }],
      blaze: [{
        color: colors.blaze[600],
        offset: "0%"
      }, {
        color: colors.black.white,
        offset: "100%"
      }]
    }
  },
  pie: {
    colors: {
      default: [colors.sand[300], colors.sand[500], colors.sand[700], colors.black[300], colors.black[500], colors.black[800], colors.forest[400], colors.forest[700], colors.blaze[500], colors.blaze[800]],
      sand: [colors.sand[300], colors.sand[500], colors.sand[700], colors.black[300], colors.black[500], colors.black[800], colors.forest[400], colors.forest[700], colors.blaze[500], colors.blaze[800]],
      forest: [colors.forest[400], colors.forest[600], colors.forest[800], colors.black[300], colors.black[500], colors.black[800], colors.sand[300], colors.sand[700], colors.blaze[500], colors.blaze[800]],
      blaze: [colors.blaze[500], colors.blaze[700], colors.blaze[900], colors.black[300], colors.black[500], colors.black[800], colors.sand[300], colors.sand[700], colors.forest[400], colors.forest[700]],
      volt: [colors.volt[500], colors.volt[700], colors.volt[900], colors.black[300], colors.black[500], colors.black[800], colors.sand[300], colors.sand[700], colors.forest[400], colors.forest[700]]
    }
  },
  stackedBar: {
    bars: {
      default: [colors.sand[300], colors.sand[500], colors.sand[700], colors.black[300], colors.black[500], colors.black[800], colors.forest[400], colors.forest[700], colors.blaze[500], colors.blaze[700]],
      sand: [colors.sand[300], colors.sand[500], colors.sand[700], colors.black[300], colors.black[500], colors.black[800], colors.forest[400], colors.forest[700], colors.blaze[500], colors.blaze[700]],
      forest: [colors.forest[400], colors.forest[600], colors.forest[800], colors.black[300], colors.black[500], colors.black[800], colors.sand[300], colors.sand[700], colors.blaze[500], colors.blaze[700]],
      blaze: [colors.blaze[500], colors.blaze[700], colors.blaze[900], colors.black[300], colors.black[500], colors.black[800], colors.sand[300], colors.sand[700], colors.forest[300], colors.forest[700]],
      volt: [colors.volt[500], colors.volt[700], colors.volt[900], colors.black[300], colors.black[500], colors.black[800], colors.sand[300], colors.sand[700], colors.forest[300], colors.forest[700]]
    },
    lines: {
      default: [colors.black[400]],
      sand: [colors.black[400]],
      forest: [colors.black[400]],
      volt: [colors.black[400]],
      blaze: [colors.black[400]]
    }
  }
};
export {
  charts as default
};
